// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3l_A3","text":"SelectPayment_text__1z5ri","title":"SelectPayment_title__1GmHu","btn":"SelectPayment_btn__2tWQD"};